export default __webpack_public_path__ + "static/media/viewer.36b4399b.svg";